'use strict';

angular.module('docketbook').
  controller('selectQuoteController', function (xeroService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid) {

    // Initialise variables to be used
    $scope.quoteSearch = "";
    $scope.quoteSelectCallback = null;
    $scope.quoteSearchList = [];
    $scope.quoteSearchLoading = false;
    $scope.quoteLoadingError = null;

    $scope.query = {
      limit: 10,
      page: 1,
      sort: 'displayName'
    };
    $scope.quotesSelected = [];

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.quoteSelectFromParent = function (cb) {
      $scope.quoteModalMode = 'select';
      $scope.updateQuoteOnSelect = false;
      $scope.quoteSearch = "";
      $scope.quoteSelectCallback = cb;
      $scope.quoteDetail = null;
      if ($scope.device == 'mobile') {

      } else {
        $("#selectQuoteModal").fadeIn(100);
        $("input[name='searchQuoteInput']").focus();
      }
      $scope.loadQuoteSearchList();
    }

    $scope.loadQuoteSearchList = function (searchValue) {
      $scope.quoteSearchLoading = true;
      $scope.promise = $q(function (resolve, reject) {
        var params = {};
        //params.status = 'DRAFT';
        params.order = 'date DESC';
        // TODO: add search and filter params
        xeroService.getXeroQuotes(params, function (quotes) {
          // filter out quote status's
          var quotesFiltered = [];
          for (var i = 0; i < quotes.length; i++) {
            if (quotes[i].status == 'DRAFT' || quotes[i].status == 'SENT' || quotes[i].status == 'ACCEPTED') {
              quotesFiltered.push(quotes[i]);
            }
          }
          $scope.quoteSearchList = quotesFiltered;
          $scope.quoteSearchListFull = angular.copy(quotesFiltered);

          $scope.quoteSearchList = Restangular.stripRestangular($scope.quoteSearchList);
          $scope.quoteSearchLoading = false;
          resolve('Done');
        }, function (err) {
          $scope.quoteSearchLoading = false;
          $scope.quoteLoadingError = "Error getting quotes";
          reject('Error');
        });
      });
    }

    $scope.selectQuote = function (quote) {
      /*if (($scope.contactModalMode === 'edit') && (!$scope.updateContactOnSelect)) {
        return;
      }*/
      $scope.quoteDetail = angular.copy(quote);
    }

    $scope.selectQuoteContinue = function () {
      if ($scope.quoteDetail) {
        $scope.quoteSelectCallback($scope.quoteDetail);
        $("#selectQuoteModal").fadeOut(100);
      }
    }

    $scope.closeQuoteSelectList = function () {
      $("#selectQuoteModal").fadeOut(100);
      if (($scope.quoteSelectCallback) && (typeof $scope.quoteSelectCallback === 'function')) {
        $scope.quoteSelectCallback(null);
      }
    }

    $scope.searchContactChange = function (searchText) {
      $scope.loadContactSearchList(searchText);
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/selectors/selectQuoteController.js